import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import lightingImg from "assets/images/sbs/lighting.png";
import ltGlobalLogo from "assets/images/sbs/lt-global-logo.png";
import triviaSubmit from "assets/images/sbs/sbs-logo-submit.png";
import { CircularProgressBar } from "components/circularProgressBar";
import Alert from "components/shared/common/alert";
import {
  divVariants,
  logoVariants,
  bounceVariants
} from "components/shared/utils/animations";
import LeaderBoard from "../lightingTrivia/LeaderBoard";

const LtQuestion = ({
  asker_id,
  roomData,
  gameCode,
  onTimesUp,
  countdown,
  playerArray,
  timerScreen,
  setCountdown,
  answeredArray,
  setTimerScreen
}) => {
  const [enableTimer, setEnableTimer] = useState(true);

  useEffect(() => {
    let player_length = playerArray.length;
    asker_id !== undefined && player_length--;

    if (player_length > 0) {
      const guessed_players_length = playerArray.filter(
        (player) => !isNaN(player.answer_time)
      ).length;
      if (player_length === 2) {
        guessed_players_length !== 0 && enableTimer && setTimerScreen(true);
      } else if (player_length === 3) {
        guessed_players_length > 1 && enableTimer && setTimerScreen(true);
      } else {
        Math.round((guessed_players_length / player_length) * 100) >= 75 &&
          enableTimer &&
          setTimerScreen(true);
      }
    }
  }, [playerArray, enableTimer]);

  let timer;
  useEffect(() => {
    timerScreen &&
      countdown > 0 &&
      (timer = setInterval(() => setCountdown(countdown - 1), 1000));
    return () => clearInterval(timer);
  }, [countdown, timerScreen]);

  useEffect(() => {
    countdown === 0 && onTimesUp();
  }, [countdown]);

  const onTimerClick = () => {
    setTimerScreen(false);
    setEnableTimer(false);
    setCountdown(5);
  };

  const scrollDivVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw", transition: { delay: 0.4 } }
  };

  const handleCheckAnswer = () => {
    if (roomData?.users.length > 0) onTimesUp();
    else Alert(400, "Need at least one player to continue.");
  };

  return (
    <>
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="small-bites-users-wrapper"
      >
        {gameCode === "LT" && !roomData?.game_state?.top_logo ? (
          <motion.h2 variants={logoVariants} className="heading">
            Lightning <img src={lightingImg} className="lighting-img" alt="" />{" "}
            Trivia
          </motion.h2>
        ) : gameCode === "LTS" ? (
          <></>
        ) : (
          <img src={ltGlobalLogo} className="ltGlobalLogo" alt="ltGlobalLogo" />
        )}

        <div className="logo-section">
          {gameCode === "LTS" && (
            <img alt="" className="lts-logo-submit" src={triviaSubmit}></img>
          )}
          <motion.p variants={bounceVariants} className="info">
            Look at your phone for the question!
          </motion.p>
        </div>
        {!timerScreen ? (
          <div
            onClick={() => setEnableTimer(!enableTimer)}
            className="timer-info"
          >
            <p className="info">
              {enableTimer
                ? "Timer will start once more players have guessed"
                : "The timer has been disabled"}
            </p>
            <span className="enable-disable-text">
              {enableTimer ? "Click to Disable" : "Click to Enable"}
            </span>
          </div>
        ) : (
          <CircularProgressBar onPress={onTimerClick} countdown={countdown} />
        )}
        <div className="players-box-wrap"></div>
        <motion.Button
          variants={scrollDivVariants}
          onClick={handleCheckAnswer}
          className="guessed-btn"
        >
          Check answer now! ({answeredArray?.length}/
          {roomData?.game_state.hasOwnProperty("asker")
            ? playerArray?.length - 1
            : playerArray?.length}
          )
        </motion.Button>
      </motion.div>
      <LeaderBoard />
    </>
  );
};

export default LtQuestion;
